'use strict';
export class GravityForm {
    #shivaListingForm;
    #shivaRepeaterItems = 1;

    constructor() {
        this.#shivaListingForm = document.getElementById("gform_4");
        this.init();
    }

    init() {
        this.hideAllHoursTypeFields();
        this.hideAllTimeSlots();
        this.setupVisitingHoursConditionalLogic();
        this.setupHoursTypeConditionalLogic();
    }

    /**
     * Hide all hours type fields on initialization
     */
    hideAllHoursTypeFields() {
        if (!this.#shivaListingForm) return;

        const hoursTypeFieldsets = this.#shivaListingForm.querySelectorAll('[id*="field_4_306"]');
        hoursTypeFieldsets.forEach(fieldset => {
            this.#toggleHoursTypeField(fieldset, false);
        });
    }

    hideAllTimeSlots() {
        if (!this.#shivaListingForm) return;

        const sameHoursFields = this.#shivaListingForm.querySelectorAll('[id*="field_4_307"]');
        sameHoursFields.forEach(field => {
            const repeaterWrapper = field.closest('.gfield_repeater_wrapper');
            if (repeaterWrapper) {
                repeaterWrapper.style.setProperty('display', 'none');
            }
        });

        const differentHoursFields = this.#shivaListingForm.querySelectorAll('[id*="field_4_310"]');
        differentHoursFields.forEach(field => {
            const repeaterWrapper = field.closest('.gfield_repeater_wrapper');
            if (repeaterWrapper) {
                repeaterWrapper.style.setProperty('display', 'none');
            }
        });
    }

    /**
     * Setup event listener for visiting hours conditional logic
     */
    setupVisitingHoursConditionalLogic() {
        if (!this.#shivaListingForm) return;

        document.addEventListener('change', (event) => {
            if (!event.target?.id?.includes('choice_4_304')) return;

            const repeaterItem = event.target.closest('.gfield_repeater_item');
            const hoursTypeFieldset = repeaterItem?.querySelector('[id*="field_4_306"]');

            if (!hoursTypeFieldset) return;

            const shouldShow = event.target.value === 'yes';
            this.#toggleHoursTypeField(hoursTypeFieldset, shouldShow);

            // Clear inputs when hiding
            if (!shouldShow) {
                this.#clearFieldInputs(hoursTypeFieldset);
            }
        });
    }

    /**
     * Setup event listener for hours type conditional logic
     */
    setupHoursTypeConditionalLogic() {
        if (!this.#shivaListingForm) return;

        document.addEventListener('change', (event) => {
            if (!event.target?.id?.includes('choice_4_306')) return;

            const repeaterItem = event.target.closest('.gfield_repeater_item');
            const sameHoursFieldset = repeaterItem?.querySelector('[id*="field_4_307"]');
            const differentHoursFieldset = repeaterItem?.querySelector('[id*="field_4_310"]');

            if (!sameHoursFieldset && !differentHoursFieldset) return;

            const selectedValue = event.target.value;

            // Handle same hours repeater
            if (sameHoursFieldset) {
                const shouldShowSame = selectedValue === 'same';
                this.#toggleTimeSlotsField(sameHoursFieldset, shouldShowSame);
                
                if (!shouldShowSame) {
                    this.#clearTimeSlotsRepeater(sameHoursFieldset);
                }
            }

            // Handle different hours repeater
            if (differentHoursFieldset) {
                const shouldShowDifferent = selectedValue === 'different';
                this.#toggleTimeSlotsField(differentHoursFieldset, shouldShowDifferent);
                
                if (!shouldShowDifferent) {
                    this.#clearTimeSlotsRepeater(differentHoursFieldset);
                }
            }
        });
    }

    /**
     * Toggle visibility of hours type field
     * @param {HTMLElement} hoursTypeFieldset - The fieldset element to toggle
     * @param {boolean} show - Whether to show or hide the field
     * @private
     */
    #toggleHoursTypeField(hoursTypeFieldset, show) {
        if (!hoursTypeFieldset) return;

        const hoursWrapper = hoursTypeFieldset.closest('.gfield_repeater_cell');
        if (!hoursWrapper) return;

        hoursWrapper.style.setProperty('display', show ? 'block' : 'none');
    }

    /**
     * Clear all inputs within a fieldset
     * @param {HTMLElement} fieldset - The fieldset containing inputs to clear
     * @private
     */
    #clearFieldInputs(fieldset) {
        if (!fieldset) return;

        const inputs = fieldset.querySelectorAll('input');
        inputs.forEach(input => {
            const inputType = input.type;

            if (['checkbox', 'radio'].includes(inputType)) {
                input.checked = false;
            } else if (['text', 'email', 'tel'].includes(inputType)) {
                input.value = '';
            }

            // Trigger change event to notify other scripts
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    /**
     * Toggle visibility of time slots repeater field
     * @param {HTMLElement} timeSlotsFieldset - The fieldset element to toggle
     * @param {boolean} show - Whether to show or hide the field
     * @private
     */
    #toggleTimeSlotsField(timeSlotsFieldset, show) {
        if (!timeSlotsFieldset) return;

        const repeaterWrapper = timeSlotsFieldset.closest('.gfield_repeater_wrapper');
        if (!repeaterWrapper) return;

        repeaterWrapper.style.setProperty('display', show ? 'block' : 'none');
    }

    /**
     * Clear all inputs within the time slots repeater and remove extra repeater items
     * @param {HTMLElement} timeSlotsFieldset - The time slots fieldset
     * @private
     */
    #clearTimeSlotsRepeater(timeSlotsFieldset) {
        if (!timeSlotsFieldset) return;

        // Clear all input values in the repeater field
        const inputs = timeSlotsFieldset.querySelectorAll('input');
        inputs.forEach(input => {
            if (['text', 'time'].includes(input.type)) {
                input.value = '';
            }
            // Trigger change event to notify other scripts
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        // Find the repeater wrapper inside the field and remove extra items
        const repeaterWrapper = timeSlotsFieldset.querySelector('.gfield_repeater_wrapper');
        if (repeaterWrapper) {
            const repeaterItems = repeaterWrapper.querySelectorAll('.gfield_repeater_item');
            repeaterItems.forEach((item, index) => {
                if (index > 0) {
                    item.remove();
                }
            });
        }
    }
}